export const MODAL_TYPE = {
    BANK_ID: 'BANK_ID',
    SWISH_HANDEL: 'SWISH_HANDEL'
};

export const PAYMENT_OPTIONS = {
    CARD: 'Card',
    PAYPAL: 'PayPal',
    APPLEPAY: 'ApplePay',
    GOOGLEPAY: 'GooglePay',
    SWISH_HANDEL: 'SwishHandel',
    VISA_MASTERCARD: 'VisaMasterCard',
    INVOICE: 'Invoice'
};

export const PAYMENT_OPTION_STATUS = {
    AVAILABLE: 'Available',
    UNAVAILABLE_DUE_TO_AMOUNT: 'UnavailableDueToAmount',
    AVAILABLE_WITH_DISTURBANCE: 'AvailableWithDisturbance'
};

export default () => ({
    shipments: [],
    isInitialized: false,
    isFetching: false,
    hasError: false,
    error: null,
    isDeleting: false,
    isUpdating: false,
    isCreating: false,
    isCreated: false,
    isCreateInitialized: false,
    ongoingPaymentAttempt: {
        shipmentPaymentAttemptId: null,
        paymentMethod: null
    },
    payment: {
        hasError: false,
        isFetching: false,
        paymentOptions: null,
        selectedPayment: null,
        paymentMethodData: null,
        modal: {
            open: ''
        }
    },
    checkoutSummary: {
        hasError: false,
        isFetching: false,
        totalCost: null,
        termsAccepted: true
    },
    itemWithoutShipment: {
        error: null,
        items: null,
        selectedShipping: null,
        buyerContactDetails: null,
        shipmentCheckoutId: null,
        isFetching: false,
        isInitialized: false
    },
    nonIntegrated: {
        open: false,
        provider: null,
        isUpdating: false,
        markedAsBooked: false,
        markedAsShipped: false,
        hasError: false
    },
    shipping: {
        shippingOptions: [],
        isShippingFetching: false,
        hasShippingError: false,
        isShippingInitialized: false
    },
    shippingConfirmation: {
        data: null,
        isInitialized: false,
        isFetching: false,
        isLongPolling: false,
        hasError: false
    },
    unbookedShipments: {
        loading: false,
        error: false,
        shipments: []
    }
});
